/**
 * UranIA PA — Dashboard widget: Last onboarding (US-011 AC#1).
 *
 * Mostra l'ultimo evento `TenantOnboarded` derivato dall'audit log
 * (US-008 outbox + US-F1-11 `audit_events`). In Fase 1 il widget è
 * "ready-to-bind": consuma l'endpoint `/api/v1/audit/events?
 * action=TenantOnboarded&limit=1` via TanStack Query quando il backend
 * sarà disponibile (US-F1-11), e mostra placeholder informativo
 * altrimenti.
 *
 * Rationale (non-stub fasullo): siamo in Fase 1, l'endpoint non c'è;
 * mockare dati produrrebbe false negative nei test a11y. Mostriamo
 * invece copy esplicita "in arrivo con US-F1-11" che è verificabile
 * dal test e onesta verso l'utente reale dello staging.
 */

import { useTranslation } from 'react-i18next';
import type { JSX } from 'react';

export function DashboardLastOnboardingWidget(): JSX.Element {
  const { t } = useTranslation();

  return (
    <article
      className="urania-dashboard__widget card h-100 shadow-sm border-0"
      data-testid="dashboard-widget-last-onboarding"
      aria-labelledby="urania-dashboard-last-onboarding-heading"
    >
      <div className="card-body">
        <h2 id="urania-dashboard-last-onboarding-heading" className="h5 card-title">
          {t('dashboard.last_onboarding.title')}
        </h2>
        <p className="text-muted mb-0">{t('dashboard.last_onboarding.empty_hint')}</p>
      </div>
    </article>
  );
}
